module.exports = __webpack_public_path__ + "austria.svg?7fc4e22077fa6b649ec4225c9e1463f3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/austria.svg
// module id = 98
// module chunks = 10